
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512","viewBox":"0 0 48 48","width":"512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#4da0d8"}},[_c('path',{attrs:{"d":"M14.2 10.3H23V.6c-3.6.6-6.8 4.3-8.8 9.7zM23 23V12.3h-9.5c-.9 3.2-1.5 6.8-1.6 10.7zM25 .6v9.7h8.8c-2-5.4-5.2-9.1-8.8-9.7zM9.9 25H.5c.2 3.9 1.2 7.5 2.9 10.7.1 0 .2-.1.3-.1h7.7c-.9-3.1-1.4-6.7-1.5-10.6zM38.1 25c-.1 3.8-.6 7.5-1.5 10.7h7.7c.1 0 .2 0 .3.1 1.7-3.2 2.8-6.8 2.9-10.7h-9.4zM23 25H11.9c.1 3.9.7 7.5 1.6 10.7H23zM9.9 23c.1-3.8.6-7.5 1.5-10.7H3.8c-.1 0-.2 0-.3-.1C1.7 15.5.7 19.1.5 23zM36.1 23c-.1-3.9-.7-7.5-1.6-10.7H25V23zM12.1 10.3c1.5-4.4 3.7-7.8 6.4-9.8-5.7 1.4-10.6 5-13.8 9.8zM12.1 37.7H4.6c3.2 4.8 8.1 8.4 13.8 9.8-2.6-2-4.8-5.4-6.3-9.8zM35.9 10.3h7.4C40.1 5.5 35.2 1.9 29.5.5c2.7 2 4.9 5.4 6.4 9.8zM35.9 37.7c-1.5 4.4-3.7 7.8-6.4 9.8 5.7-1.4 10.6-5 13.8-9.8zM44.2 12.3h-7.7c.9 3.2 1.4 6.8 1.5 10.7h9.4c-.2-3.9-1.2-7.5-2.9-10.7h-.3zM33.8 37.7H25v9.7c3.6-.6 6.8-4.3 8.8-9.7zM25 25v10.7h9.5c.9-3.2 1.5-6.8 1.6-10.7zM23 47.4v-9.7h-8.8c2 5.4 5.2 9.1 8.8 9.7z"}})])])
          )
        }
      }
    